import React, { useState } from 'react'
import ListItem from '@mui/material/List'
import { NavLink } from 'react-router-dom'
import './style.css'

const menus = [
  { id: 1, title: 'Home', link: '/' },
  { id: 2, title: 'About', link: '/about' },
  { id: 3, title: 'Platform', link: '/platform' },
  { id: 4, title: 'Partners', link: '/partners' },
  { id: 5, title: 'How it works', link: '/how-it-works' },
  { id: 6, title: 'Contact', link: '/contact' },
]

const MobileMenu = () => {
  const [menuActive, setMenuState] = useState(false)

  const ClickHandler = () => {
    window.scrollTo(10, 0)
  }

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? 'show' : ''}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(!menuActive)}>
            <i className="ti-close"></i>
          </div>
        </div>

        <ul className="responsivemenu">
          {menus.map((item) => (
            <ListItem key={item.id}>
              <NavLink className="active" onClick={ClickHandler} to={item.link}>
                {item.title}
              </NavLink>
            </ListItem>
          ))}
        </ul>
      </div>

      <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  )
}

export default MobileMenu
